module.exports = __webpack_public_path__ + "static/media/proteccion.1ddc4c06.jpg";